module.exports = __webpack_public_path__ + "static/media/icomoon.e9b8aa88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.svg?hujj0d
// module id = ./src/assets/fonts/icomoon.svg?hujj0d
// module chunks = 23